import React from "react";
import { emitOnePassAccountManagementAction } from "@catchoftheday/analytics";
import { Box, Text } from "@catchoftheday/cg-components";
import { triggerOnePassUpsellModal } from "../../../utilities";
import { PlanOptionsZone, SideImageZone, UpsellBoxZone, UpsellCopyZone } from "../../layouts/UpsellBoxLayout/UpsellBoxLayout";
import { UpsellBoxSideImage } from "../../pure/image-assets/UpsellBoxSideImage";
import { PlanOptions } from "../../pure/PlanOptions";
import { SubscriptionCTA } from "../../pure/SubscriptionCTA";
import { UpsellBoxCopy } from "../../pure/UpsellBoxCopy";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellBoxContainer = function UpsellBoxContainer(_ref) {
  var isFreeTrialEligible = _ref.isFreeTrialEligible;

  var handleCTAClick = function handleCTAClick() {
    triggerOnePassUpsellModal();
    emitOnePassAccountManagementAction(isFreeTrialEligible ? "freeTrial" : "join");
  };

  var handleLearnMoreClick = function handleLearnMoreClick() {
    emitOnePassAccountManagementAction("learnMore");
  };

  return ___EmotionJSX(UpsellBoxZone, null, ___EmotionJSX(UpsellCopyZone, null, ___EmotionJSX(UpsellBoxCopy, {
    headingText: isFreeTrialEligible ? "Join OnePass for benefits from Australia's favourite retail brands" : "We miss you, come back to OnePass for amazing benefits",
    onLearnMoreClick: handleLearnMoreClick
  })), ___EmotionJSX(PlanOptionsZone, null, ___EmotionJSX(PlanOptions, null), ___EmotionJSX(Box, null, ___EmotionJSX(SubscriptionCTA, {
    onClick: handleCTAClick
  }, isFreeTrialEligible ? "Start free 30 day trial" : "Join OnePass"), ___EmotionJSX(Text, {
    fontSize: "sm",
    textAlign: "center",
    fontWeight: "medium",
    m: 0,
    mt: 2
  }, isFreeTrialEligible ? "Billing starts at the end of trial. " : "", "Cancel anytime."))), ___EmotionJSX(SideImageZone, null, ___EmotionJSX(UpsellBoxSideImage, null)));
};